import { permissions } from '@mocks/permissions'
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  data () {
    return {
      permissions,
      isShowFilter: true,
      isDataPageLoading: true,
      config: {
        business_entity_type: {
          company: {
            id: 1
          }
        }
      },
      clientsModal: {
        show: false
      },
      filters: {
        clientId: {
          type: 'select',
          name: 'client_id',
          label: 'Clients',
          selectLabel: 'full_name',
          valueField: 'id',
          options: []
        },
        contractorId: {
          type: 'select',
          name: 'contractor_id',
          label: 'Contractors',
          valueField: 'id',
          selectLabel: 'name',
          options: []
        },
        partnerId: {
          type: 'select',
          name: 'partner_id',
          label: 'Partners',
          valueField: 'id',
          selectLabel: 'company_name',
          options: []
        },
        currencyId: {
          type: 'select',
          name: 'currency_id',
          label: 'Currency',
          selectLabel: 'name',
          valueField: 'id',
          options: []
        },
        country: {
          type: 'select',
          name: 'country_id',
          label: 'Country',
          options: [],
          selectLabel: 'name',
          valueField: 'id',
          placeholder: 'Country'
        },
        businessEntityTypeId: {
          type: 'select',
          name: 'business_entity_type_id',
          label: 'Business entity type',
          selectLabel: 'type',
          valueField: 'id',
          options: []
        },
        firstName: {
          type: 'input',
          name: 'first_name',
          label: 'First name',
          placeholder: 'First name'
        },
        lastName: {
          type: 'input',
          name: 'last_name',
          label: 'Last name',
          placeholder: 'Last name'
        },
        companyName: {
          type: 'input',
          name: 'company_name',
          label: 'Company name',
          placeholder: 'Company name'
        },
        sign: {
          type: 'select',
          name: 'sign_id',
          label: 'Sign',
          selectLabel: 'owner',
          valueField: 'id',
          options: [],
          value: null
        }
      },
      tableRowModal: {
        fields: [
          {
            key: 'name',
            label: 'Name'
          },
          {
            key: 'address',
            label: 'Address'
          },
          {
            key: 'sign.owner',
            label: 'Sign'
          },
          {
            key: 'address_national',
            label: 'Address National'
          },
          {
            key: 'bank_address',
            label: 'Bank Address'
          },
          {
            key: 'bank_address',
            label: 'Bank Address'
          },
          {
            key: 'bank_correspondent_address',
            label: 'Bank Correspondent Address'
          },
          {
            key: 'bank_correspondent_account',
            label: 'Bank Correspondent Account'
          },
          {
            key: 'bank_correspondent_iban',
            label: 'Bank Correspondent Iban'
          },
          {
            key: 'bank_correspondent_mfi',
            label: 'Bank Correspondent MFI'
          },
          {
            key: 'bank_correspondent_name',
            label: 'Bank Correspondent Name'
          },
          {
            key: 'bank_correspondent_swift',
            label: 'Bank Correspondent Swift'
          },
          {
            key: 'bank_mfi',
            label: 'Bank MFI'
          },
          {
            key: 'bank_name',
            label: 'Bank Name'
          },
          {
            key: 'business_entity_type.type',
            label: 'Business entity type'
          },
          {
            key: 'city',
            label: 'City'
          },
          {
            key: 'city_national',
            label: 'City national'
          },
          {
            key: 'company_name',
            label: 'Company name'
          },
          {
            key: 'company_name_national',
            label: 'Company name national'
          },
          {
            key: 'country.name',
            label: 'Country'
          },
          {
            key: 'currency.code',
            label: 'Currency'
          },
          {
            key: 'email',
            label: 'Email'
          },
          {
            key: 'extract_from_unified_register',
            label: 'Extract from unified register'
          },
          {
            key: 'first_name',
            label: 'First name'
          },
          {
            key: 'last_name',
            label: 'Last name'
          },
          {
            key: 'last_name_national',
            label: 'Last name national'
          },
          {
            key: 'first_name_national',
            label: 'First name national'
          },
          {
            key: 'iban',
            label: 'Iban'
          },
          {
            key: 'phone',
            label: 'Phone'
          },
          {
            key: 'second_name_national',
            label: 'Second name national'
          },
          {
            key: 'summary',
            label: 'Summary'
          },
          {
            key: 'swift',
            label: 'Swift'
          },
          {
            key: 'tax_registration_number',
            label: 'Tax registration number'
          },
          {
            key: 'zip_code',
            label: 'Zip code'
          }
        ]
      },
      table: {
        slots: {
          client: {
            name: 'client'
          }
        },
        fields: [
          {
            key: 'name',
            label: 'Name'
          },
          {
            key: 'client.full_name',
            label: 'Client'
          },
          {
            key: 'contractor.name',
            label: 'Contractor'
          },
          {
            key: 'partner.company_name',
            label: 'Partner'
          },
          {
            key: 'currency.code',
            label: 'Currency'
          },
          {
            key: 'country.name',
            label: 'Country'
          },
          {
            key: 'business_entity_type.type',
            label: 'Business entity type'
          },
          {
            key: 'first_name',
            label: 'First name',
            sortable: true
          },
          {
            key: 'last_name',
            label: 'Last name',
            sortable: true
          },
          {
            key: 'company_name',
            label: 'Company name',
            sortable: true
          },
          {
            key: 'sign.owner',
            label: 'Sign',
            sortable: true
          },
          {
            key: 'actions',
            label: 'Actions',
            class: 'column_action text-left'
          }
        ]
      },
      tableParams: {
        filters: null,
        sorting: null,
        currentPage: '?page=1'
      },
      createModal: {
        show: false,
        title: '',
        submitButtonText: 'Create',
        form: null
      },
      editModal: {
        show: false,
        title: '',
        submitButtonText: 'Save',
        form: null
      },
      mainFormMock: {
        'name': {
          type: 'input',
          name: 'name',
          label: 'Name',
          placeholder: 'Bank details name',
          value: null,
          class: 'col-12'
        },
        'currency': {
          type: 'select',
          name: 'currency_id',
          label: 'Currency*',
          selectLabel: 'name',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            { name: 'required' }
          ],
          class: 'col-12'
        },
        'business_entity_type': {
          type: 'select',
          name: 'business_entity_type_id',
          label: 'Business entity type*',
          selectLabel: 'type',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            { name: 'required' }
          ],
          class: 'col-12'
        },
        'company_name': {
          type: 'slot',
          slotName: 'companyName',
          name: 'company_name',
          label: 'Company name*',
          placeholder: 'Company name',
          validation: [
            { name: 'required' }
          ],
          skipValidation: (fields) => !fields.business_entity_type.value || fields.business_entity_type.value.id !== 1,
          value: null,
          class: 'col-12'
        },
        'company_name_national': {
          type: 'slot',
          slotName: 'companyNameNational',
          name: 'company_name_national',
          label: 'Company name national*',
          placeholder: 'Company name national',
          validation: [
            { name: 'required' }
          ],
          skipValidation: (fields) => !fields.business_entity_type.value || fields.business_entity_type.value.id !== 1,
          value: null,
          class: 'col-12'
        },
        'first_name': {
          type: 'input',
          name: 'first_name',
          label: 'First name',
          placeholder: 'First name',
          value: null,
          class: 'col-12'
        },
        'first_name_national': {
          type: 'input',
          name: 'first_name_national',
          label: 'First name national',
          placeholder: 'First name national',
          value: null,
          class: 'col-12'
        },
        'second_name_national': {
          type: 'input',
          name: 'second_name_national',
          label: 'Second name national',
          placeholder: 'Second name national',
          value: null,
          class: 'col-12'
        },
        'last_name': {
          type: 'input',
          name: 'last_name',
          label: 'Last name',
          placeholder: 'Last name',
          value: null,
          class: 'col-12'
        },
        'last_name_national': {
          type: 'input',
          name: 'last_name_national',
          label: 'Last name national',
          placeholder: 'Last name national',
          value: null,
          class: 'col-12'
        },
        'email': {
          type: 'input',
          name: 'email',
          label: 'Email*',
          typeInput: 'email',
          placeholder: 'Email',
          validation: [
            { name: 'required' }
          ],
          value: null,
          class: 'col-12'
        },
        'phone': {
          type: 'input',
          name: 'phone',
          label: 'Phone',
          placeholder: 'Phone',
          value: null,
          class: 'col-12'
        },
        'tax_registration_number': {
          type: 'input',
          name: 'tax_registration_number',
          label: 'Tax registration number',
          placeholder: 'Tax registration number',
          value: null,
          class: 'col-12'
        },
        'extract_from_unified_register': {
          type: 'input',
          name: 'extract_from_unified_register',
          label: 'Extract from unified register',
          placeholder: 'Extract from unified register',
          value: null,
          class: 'col-12'
        },
        'country': {
          type: 'select',
          name: 'country_id',
          label: 'Country*',
          selectLabel: 'name',
          valueField: 'id',
          options: [],
          validation: [
            { name: 'required' }
          ],
          value: null,
          class: 'col-12'
        },
        'city': {
          type: 'input',
          name: 'city',
          label: 'City*',
          placeholder: 'City',
          validation: [
            { name: 'required' }
          ],
          value: null,
          class: 'col-12'
        },
        'city_national': {
          type: 'input',
          name: 'city_national',
          label: 'City national*',
          placeholder: 'City national',
          validation: [
            { name: 'required' }
          ],
          value: null,
          class: 'col-12'
        },
        'address': {
          type: 'input',
          name: 'address',
          label: 'Address*',
          placeholder: 'Address',
          value: null,
          class: 'col-12',
          validation: [
            { name: 'required' }
          ]
        },
        'address_national': {
          type: 'input',
          name: 'address_national',
          label: 'Address national*',
          placeholder: 'Address National',
          value: null,
          class: 'col-12',
          validation: [
            { name: 'required' }
          ]
        },
        'zip_code': {
          type: 'input',
          name: 'zip_code',
          label: 'Zip code',
          placeholder: 'Zip code',
          value: null,
          class: 'col-12'
        },
        'bank_name': {
          type: 'input',
          name: 'bank_name',
          label: 'Bank name*',
          placeholder: 'Bank name',
          validation: [
            { name: 'required' }
          ],
          value: null,
          class: 'col-12'
        },
        'bank_mfi': {
          type: 'input',
          name: 'bank_mfi',
          label: 'Bank Mfi',
          placeholder: 'Bank Mfi',
          value: null,
          class: 'col-12'
        },
        'bank_address': {
          type: 'input',
          name: 'bank_address',
          label: 'Bank address',
          placeholder: 'Bank address',
          value: null,
          class: 'col-12'
        },
        'vat': {
          type: 'input',
          name: 'vat',
          label: 'VAT',
          placeholder: 'VAT',
          value: null,
          class: 'col-12'
        },
        'iban': {
          type: 'input',
          name: 'iban',
          label: 'IBAN',
          placeholder: 'IBAN',
          value: null,
          class: 'col-12'
        },
        'account': {
          type: 'input',
          name: 'account',
          label: 'Account',
          placeholder: 'Account',
          value: null,
          class: 'col-12'
        },
        'swift': {
          type: 'input',
          name: 'swift',
          label: 'SWIFT',
          placeholder: 'SWIFT',
          value: null,
          class: 'col-12'
        },
        'bank_correspondent_name': {
          type: 'input',
          name: 'bank_correspondent_name',
          label: 'Bank correspondent name',
          placeholder: 'Bank correspondent name',
          value: null,
          class: 'col-12'
        },
        'bank_correspondent_mfi': {
          type: 'input',
          name: 'bank_correspondent_mfi',
          label: 'Bank correspondent mfi',
          placeholder: 'Bank correspondent mfi',
          value: null,
          class: 'col-12'
        },
        'bank_correspondent_address': {
          type: 'input',
          name: 'bank_correspondent_address',
          label: 'Bank correspondent address',
          placeholder: 'Bank correspondent address',
          value: null,
          class: 'col-12'
        },
        'bank_correspondent_iban': {
          type: 'input',
          name: 'bank_correspondent_iban',
          label: 'Bank correspondent IBAN',
          placeholder: 'Bank correspondent IBAN',
          value: null,
          class: 'col-12'
        },
        'bank_correspondent_account': {
          type: 'input',
          name: 'bank_correspondent_account',
          label: 'Bank correspondent account',
          placeholder: 'Bank correspondent account',
          value: null,
          class: 'col-12'
        },
        'bank_correspondent_swift': {
          type: 'input',
          name: 'bank_correspondent_swift',
          label: 'Bank correspondent swift',
          placeholder: 'Bank correspondent swift',
          value: null,
          class: 'col-12'
        }
      }
    }
  },
  beforeDestroy () {
    this.tableParams = {
      filters: null,
      sorting: null,
      currentPage: '?page=1'
    }
  },
  created () {
    this.getCreateEditModal()
    this.fetchAllData()
  },
  computed: {
    ...mapGetters({
      getBankDetails: 'finances/getBankDetails',
      getClientsBankDetails: 'finances/getClientsBankDetails',
      getClientsBankDetailsAll: 'finances/getClientsBankDetailsAll',
      getAllClients: 'finances/getAllClients',
      getAllPartners: 'partners/getAllPartners',
      getBusinessEntityTypes: 'finances/getBusinessEntityTypes',
      getCountries: 'countries/getCountries',
      getAllCurrencies: 'getCurrencies',
      getBankDetailsSigns: 'finances/getBankDetailsSigns'
    }),
    getCurrencies () {
      return this.getAllCurrencies.filter(currency => currency.code !== 'RUB')
    },
    getTableFields () {
      const currentTableFields = []
      const allTableFields = JSON.parse(JSON.stringify(this.table.fields))
      if (this.currentFields.length) {
        for (const i in this.currentFields) {
          const fieldIndex = allTableFields.map(item => item.key).indexOf(this.currentFields[i])
          currentTableFields.push(allTableFields[fieldIndex])
        }
      }
      return currentTableFields
    },
    getAllUsers () {
      const allUsers = this.$store.getters.getAllUsers || []
      return allUsers || []
    },
    getBankDetailsTableData () {
      return this.getBankDetails.data || null
    }
  },
  methods: {
    getCreateEditModal () {
      this.createModal.form = cloneDeep(this.formMock)
      this.createModal.title = `Create ${this.modalTitle}`
      this.editModal.form = cloneDeep(this.formMock)
      this.editModal.title = `Edit ${this.modalTitle}`
    },
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    showCreateModal () {
      this.createModal.show = true
    },
    hideCreateModal () {
      this.createModal.show = false
    },
    showEditModal (params) {
      this.editModal.show = true
      this.setParamsForEditModal(params)
    },
    hideEditModal () {
      this.editModal.show = false
    },
    resetCreateModalForm () {
      for (var name in this.createModal.form) {
        if (this.createModal.form[name].value) {
          this.createModal.form[name].value = null
        }
      }
    },
    setParamsForEditModal (params) {
      for (let key in this.editModal.form) {
        this.editModal.form[key]['value'] = params[key] ?? null
      }
    },
    setParamsFilters (data) {
      const filters = Object.values(data).reduce(function (state, current) {
        if (current['value']) {
          const value = typeof current['value'] === 'object'
            ? current['value'][current['valueField']] : current['value']
          state += `&filter[${current.name}]=${value}`
        }
        return state
      }, '')

      this.tableParams.filters = filters || null
    },
    setParamsSort (sortDesc, sortBy) {
      if (sortBy) {
        const sortDirection = sortDesc ? 'desc' : 'asc'
        this.tableParams.sorting = `&sort[${sortBy}]=${sortDirection}`
      }
    },
    setParamsCurrentPage (currentPage = 1) {
      this.tableParams.currentPage = `?page=${currentPage}`
    },
    async fetchCurrencies () {
      if (this.getCurrencies.length) return

      return this.$api.finances.getCurrencies()
    },
    async fetchAllClients () {
      if (this.getAllClients.length) return

      return this.$api.finances.getAllFinanceClients()
    },
    async fetchAllContractors () {
      if (this.getAllUsers.length) return

      return this.$api.users.getAllUsers()
    },
    async fetchAllPartners () {
      if (this.getAllPartners.length) return

      return this.$api.partners.getAllPartners()
    },
    async fetchCountries () {
      if (this.getCountries.length) return

      return this.$api.country.getCountries()
    },
    async fetchBusinessEntityTypes () {
      if (this.getBusinessEntityTypes.length) return

      return this.$api.finances.getBusinessEntityTypesController()
    },
    prepareDataForEditAndCreateRequest (fields) {
      let data = {}

      for (let key in fields) {
        const field = fields[key]
        const name = field['name']
        const value = field['value']

        if (Object.prototype.toString.call(value) === '[object Array]' && value) {
          for (let valueItemKey in value) {
            const valueItemValue = value[valueItemKey]
            data[name] = data[name] ?? []
            data[name][valueItemKey] = (typeof valueItemValue === 'object' && valueItemValue && field['valueField']) ? valueItemValue[field['valueField']] : valueItemValue
          }
        } else {
          data[name] = (typeof value === 'object' && value && field['valueField']) ? value[field['valueField']] : value
        }
      }
      if (fields.business_entity_type.value.type !== 'Company') {
        data['company_name'] = ''
        data['company_name_national'] = ''
      }

      return data
    },
    isBusinessEntityCompany (businessEntityType) {
      return businessEntityType.value ? businessEntityType.value.id === this.config.business_entity_type.company.id : false
    },
    setFilterBankDetails (data) {
      this.setParamsFilters(data)
      this.setParamsCurrentPage()
      this.fetchBankDetails()
    },
    updateBankDetails (data) {
      if (!data) return this.fetchBankDetails()

      const { currentPage, sortDesc, sortBy } = data

      this.setParamsCurrentPage(currentPage)
      this.setParamsSort(sortDesc, sortBy)

      this.fetchBankDetails()
    },
    fetchBankDetails () {
      let params = this.tableParams.currentPage
      params += '&ownership_id=' + this.ownershipId

      if (this.tableParams.sorting) {
        params += this.tableParams.sorting
      }
      if (this.tableParams.filters) {
        params += this.tableParams.filters
      }

      this._toggleDataPageLoading(() => this.$api.finances.getBankDetails(params))
    },
    editBankDetails (fields) {
      const data = this.prepareDataForEditAndCreateRequest(fields)
      data.ownership_id = this.ownershipId

      this._toggleDataPageLoading(async () => {
        await this.$api.finances.editBankDetails(data)
        this.$snotify.success(
          'Bank details updated successfully',
          'Success',
          this.$store.state.snotify
        )
        this.hideEditModal()
        this.updateBankDetails()
      })
    },

    async removeBankDetails (item) {
      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete this bank detail?'
      )

      if (!confirm) return

      this._toggleDataPageLoading(async () => {
        const deleteResponse = await this.$api.finances.removeBankDetails(item.id)
        this.$snotify.success(
          deleteResponse.data,
          'Success',
          this.$store.state.snotify
        )
        this.updateBankDetails()
      })
    },
    async createBankDetails (fields) {
      const data = this.prepareDataForEditAndCreateRequest(fields)
      data.ownership_id = this.ownershipId

      this._toggleDataPageLoading(async () => {
        await this.$api.finances.createBankDetails(data)
        this.$snotify.success(
          'Bank details created successfully',
          'Success',
          this.$store.state.snotify
        )
        this.hideCreateModal()
        this.updateBankDetails()
      })
    }
  }
}
